import script from "./lyFormDesign.vue?vue&type=script&setup=true&lang=js"
export * from "./lyFormDesign.vue?vue&type=script&setup=true&lang=js"

import "./lyFormDesign.vue?vue&type=style&index=0&id=7580ec3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7580ec3a"]])

export default __exports__